import { Component, OnInit } from '@angular/core';
import 'hammerjs';
import { NguCarousel } from '@ngu/carousel';
import {TranslationsService} from '../services/translations.service';
import {BuildingService} from '../services/building.service';
import {RoomsService} from '../services/rooms.service';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {Config} from '../config';
import { Meta } from '@angular/platform-browser';
import {AboutService} from '../services/about.service';
import {SEOService} from "../services/seoservice.service";

@Component({
  selector: 'app-rooms',
  templateUrl: './rooms.component.html',
  styleUrls: ['./rooms.component.css']
})
export class RoomsComponent implements OnInit {
  public carouselTile: NguCarousel;
  public carouselTile1: NguCarousel;
  public backendUrl: any = new Config();
  book: any;
  dateObj: any;
  dateObj1: any;
  backgroundImages: any;
  words: any;
  lang: any;
  buildings: any;
  buildingId: string;
  roomId: string;
  rooms: any;
  url: any;
  urlArr: any;
  sum: number;
  buildingsByRooms: any;
  roomsLoop: any;
  error: any;
  smonth: number;
  sday: number;
  syear: number;
  emonth: number;
  eday: number;
  eyear: number;
  price: any = [];
  day: any;
  alertShowHide: any;
  sumRooms: number;
  constructor(private translationsService: TranslationsService,
              private rout: ActivatedRoute,
              private router: Router,
              private seoService: SEOService,
              private roomsService: RoomsService,
              private readonly meta: Meta,
              private buildingService: BuildingService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.url = event.url;
        this.urlArr = this.url.split('/');
        this.getRooms(this.urlArr[2], this.urlArr[3]);
      }
    });
    this.translationsService.langName$.subscribe((res) => {
      this.lang = res;
    });
  }

  ngOnInit() {
    this.alertShowHide = [];
    this.error = [false, false, false, false, false, false, false, false]
    this.book = {
      start: '',
      end: '',
      rooms: '1',
      adult: '',
      child: '',
      email: '',
      fullName: '',
      phone: '',
      buildingId: '',
      roomId: '',
      high: 0,
      low: 0,
      sum: 0
    };
    this.sumRooms = Number(this.book.rooms);
    this.roomsLoop = [];
    this.buildingsByRooms = [];
    this.rout.params.subscribe( param => {
      this.buildingId = param['buildingId'];
      this.roomId = param['id'];
    });
    this.backgroundImages = [];
    this.lang = localStorage.getItem('lang');
    this.translationsService.getTranslations().subscribe(resp => {
      if (!resp.error) {
        this.words = resp.data[0];
        this.buildingService.getBuildings().subscribe(respo => {
          if (!respo.error) {
            this.buildings = respo.data;
            this.getRooms(this.buildingId, this.roomId);
            if (this.roomId === 'all') {
              if (localStorage.getItem('bookData')) {
                this.book = JSON.parse(localStorage.getItem('bookData'));
                this.sumRooms = Number(this.book.rooms);
                this.checkSum();
              }
            }
          }
        });
      }
    });

    this.carouselTile = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: false
      },
      load: 2,
      touch: true,
      loop: true,
      custom: 'banner'
    };

    this.carouselTile1 = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: false
      },
      load: 2,
      touch: true,
      loop: true,
      custom: 'banner'
    };
  }

  getRooms(bId, rId) {
    this.buildingsByRooms = [];
    this.roomsLoop = [];
    this.roomsService.getRoom( bId, rId).subscribe(response => {
      if (!response.error) {
        this.rooms = response.data;
        const imagUrl = this.rooms[0].images[0].name;
        this.seoService.updateMeta(this.rooms[0].title[this.lang],
          this.rooms[0].descr[this.lang],
          this.backendUrl.backendUrl + 'images/' + imagUrl);
        // this.meta.updateTag({name: 'og:image', content: this.backendUrl.backendUrl + 'images/' + imagUrl});
        // this.meta.updateTag({name: 'title', content: this.rooms[0].title[this.lang]});
        for (let i = 0; i < this.rooms.length; i++) {
          if (this.rooms[i].buildingId === bId) {
            this.roomsLoop.push(this.rooms[i]);
            this.price.push(0);
            this.alertShowHide.push(false);
          }
          if (i === 0) {
            this.buildingsByRooms.push(this.rooms[i].buildingId);
          }else {
            if (this.rooms[i].buildingId !== this.rooms[(i - 1)].buildingId._id) {
              this.buildingsByRooms.push(this.rooms[i].buildingId);
            }
          }
          this.rooms[i].buildingId = this.buildings.filter( obj => {
            return obj._id === this.rooms[i].buildingId;
          })[0];
          for (let j = 0; j < this.rooms[i].images.length; j++) {
            if (this.rooms[i].images[j].bc) {
              this.backgroundImages.push(this.rooms[i].images[j].name);
            }
          }
        }
        this.checkSum();
        for (let i = 0; i < this.buildingsByRooms.length; i++) {
          this.buildingsByRooms[i] = this.buildings.filter( obj => {
            return obj._id === this.buildingsByRooms[i];
          })[0];
        }
      }
    });
  }


  bookNow(bId, rId, lowPrice, highPrice, index) {
    if (this.book.start) {
      if (new Date(this.book.start).toISOString() < new Date().toISOString().split('T')[0]) {
        this.error[0] = true;
      }else {
        this.error[0] = false;
        if (this.book.end) {
          if (new Date(this.book.end).toISOString() < new Date().toISOString().split('T')[0]) {
            this.error[1] = true;
          }else {
            if (new Date(this.book.start) <= new Date(this.book.end)) {
              this.error[0] = false;
              this.error[1] = false;
            }else {
              this.error[0] = true;
              this.error[1] = true;
            }
          }
        }else {
          this.error[1] = true;
        }
      }
    }else {
      this.error[0] = true;
      if (this.book.end) {
        if (new Date(this.book.end).toISOString() < new Date().toISOString().split('T')[0]) {
          this.error[1] = true;
        }else {
          this.error[1] = false;
          if (new Date(this.book.start) <= new Date(this.book.end)) {
            this.error[0] = false;
            this.error[1] = false;
          }else {
            this.error[0] = true;
          }
        }
      }else {
        this.error[1] = true;
      }
    }

    if (this.book.rooms) {
      this.error[2] = false;
    }else {
      this.error[2] = true;
    }
    if (this.book.adult) {
      this.error[3] = false;
    }else {
      this.error[3] = true;
    }
    if (this.book.child) {
      this.error[4] = false;
    }else {
      this.error[4] = true;
    }
    if (this.book.email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(String(this.book.email).toLowerCase())) {
        this.error[5] = false;
      }else {
        this.error[5] = true;
      }
    }else {
      this.error[5] = true;
    }
    if (this.book.fullName) {
      this.error[6] = false;
    }else {
      this.error[6] = true;
    }
    if (this.book.phone) {
      this.error[7] = false;
    }else {
      this.error[7] = true;
    }
    if (this.error.indexOf(true) >= 0) {
      window.scroll(0, 0);
      return false;
    }else {
      this.book.low = lowPrice;
      this.book.high = highPrice;
      this.book.sum = this.book.rooms ? Number(this.book.rooms) * this.price[index] : this.price[index];

      this.roomsService.getRoomsCats().subscribe(res => {
        if (!res.error) {
          this.book.roomId = res.data.filter(obj => {
            return obj._id === rId;
          })[0].title[this.lang];
          this.book.buildingId = bId.name[this.lang];
          this.roomsService.orderRoom(this.book).subscribe( respo => {
            if (!respo.error) {
              this.alertShowHide[index] = true;
              this.roomsService.sendBookingEmail(this.book).subscribe(respon => {
                if (!respon.error) {
                  setTimeout(() => {
                    this.alertShowHide[index] = false;
                    localStorage.removeItem('bookData');
                    this.book = {
                      start: '',
                      end: '',
                      rooms: '',
                      adult: '',
                      child: '',
                      email: '',
                      fullName: '',
                      phone: '',
                      buildingId: '',
                      roomId: '',
                      high: 0,
                      low: 0,
                      sum: 0
                    };
                  }, 5000);
                }else {
                  this.book = {
                    start: '',
                    end: '',
                    rooms: '',
                    adult: '',
                    child: '',
                    email: '',
                    fullName: '',
                    phone: '',
                    buildingId: '',
                    roomId: '',
                    high: 0,
                    low: 0,
                    sum: 0
                  };
                }
              });
            }
          });
        }
      });
    }
  }

  changeSumByRooms(rooms) {
    this.sumRooms = Number(this.book.rooms);
  }

  checkSum() {
    this.price = [];
    if (this.book.start.length > 0 && this.book.end.length > 0) {
      for (let i = 0; i < this.roomsLoop.length; i++) {
        let sPrice = Number(this.roomsLoop[i].price.low);
        let hPrice = Number(this.roomsLoop[i].price.high);
        this.dateObj = new Date(this.book.start);
        this.smonth = this.dateObj.getUTCMonth() + 1;
        this.sday = this.dateObj.getUTCDate();
        this.syear = this.dateObj.getUTCFullYear();
        this.dateObj1 = new Date(this.book.end);
        this.emonth = this.dateObj1.getUTCMonth() + 1;
        this.eday = this.dateObj1.getUTCDate();
        this.eyear = this.dateObj1.getUTCFullYear();
        let rstart, rend;
        if (this.eyear === new Date().getUTCFullYear()) {
          rstart = new Date('03/15/' + this.syear);
          rend = new Date('10/15/' + this.eyear);
        }else if (this.syear === new Date().getUTCFullYear() && this.eyear > new Date().getUTCFullYear()) {
          rstart = new Date('10/15/' + this.syear);
          rend = new Date('03/15/' + this.eyear);
        }

        this.price[i] = 0;
        let that = this;
        var calcForDay = function(index) {
          that.day = new Date( (that.dateObj / 1000 + (86400 * index ) ) * 1000);
          if ( (that.day / 1000) > ((that.dateObj1 / 1000) - 1) ) {
            return false;
          } else {
            if ((rstart / 1000 ) < (that.day / 1000)  && (that.day / 1000 ) < (rend / 1000) - 1) {
              if (that.eyear === new Date().getUTCFullYear()) {
                that.price[i] += hPrice;
              }else if (that.syear === new Date().getUTCFullYear() && that.eyear > new Date().getUTCFullYear()) {
                that.price[i] += sPrice;
              }
            } else {
              if (that.eyear === new Date().getUTCFullYear()) {
                that.price[i] += sPrice;
              }else if (that.syear === new Date().getUTCFullYear() && that.eyear > new Date().getUTCFullYear()) {
                that.price[i] += hPrice;
              }
            }
            if (localStorage.getItem('bookData')) {
              localStorage.setItem('bookData', JSON.stringify(that.book));
            }
            index++;
            calcForDay(index);
          }
        }
        calcForDay(0);
      }
    }

  }

}



// WEBPACK FOOTER //
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/rooms/rooms.component.ts